'use strict';

(function () {
  'use strict';

  angular.module('msOnboarding', ['msUtility', 'ngAnimate', 'msCore', 'msAssessment', 'msProfile', 'msActivityServices', 'msActivities', 'smoothScroll', 'msTracker', 'msSleep']).constant('context', 'onboarding');
})();